(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('native-language', {
            parent: 'entity',
            url: '/native-language?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.nativeLanguage.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/native-language/native-languages.html',
                    controller: 'NativeLanguageController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nativeLanguage');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('native-language-detail', {
            parent: 'entity',
            url: '/native-language/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.nativeLanguage.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/native-language/native-language-detail.html',
                    controller: 'NativeLanguageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nativeLanguage');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'NativeLanguage', function($stateParams, NativeLanguage) {
                    return NativeLanguage.get({id : $stateParams.id});
                }]
            }
        })
        .state('native-language.new', {
            parent: 'native-language',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/native-language/native-language-dialog.html',
                    controller: 'NativeLanguageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('native-language', null, { reload: true });
                }, function() {
                    $state.go('native-language');
                });
            }]
        })
        .state('native-language.edit', {
            parent: 'native-language',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/native-language/native-language-dialog.html',
                    controller: 'NativeLanguageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NativeLanguage', function(NativeLanguage) {
                            return NativeLanguage.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('native-language', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('native-language.delete', {
            parent: 'native-language',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/native-language/native-language-delete-dialog.html',
                    controller: 'NativeLanguageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NativeLanguage', function(NativeLanguage) {
                            return NativeLanguage.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('native-language', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
